import { apiClient } from "./client";

export type HandoffSeverity = "NORMAL" | "WARNING" | "CRITICAL";

export type Handoff = {
  id: string;
  assignment_id: string;
  author_user_id: string | null;
  body: string;
  severity: HandoffSeverity;
  created_at: string;
  updated_at: string;
  acknowledged_by_me: boolean;
  ack_count: number;
};

export type PendingHandoff = {
  handoff: Handoff;
  organization_id: string;
  organization_name: string;
  outgoing_date: string;
  outgoing_slot_label: string;
  author_display_name: string | null;
};

export async function getHandoff(assignmentId: string): Promise<Handoff | null> {
  const { data } = await apiClient.get<Handoff | null>(
    `/api/v1/assignments/${assignmentId}/handoff`,
  );
  return data;
}

export async function upsertHandoff(
  assignmentId: string,
  body: string,
  severity: HandoffSeverity,
): Promise<Handoff> {
  const { data } = await apiClient.put<Handoff>(
    `/api/v1/assignments/${assignmentId}/handoff`,
    { body, severity },
  );
  return data;
}

export async function deleteHandoff(assignmentId: string): Promise<void> {
  await apiClient.delete(`/api/v1/assignments/${assignmentId}/handoff`);
}

export async function ackHandoff(
  handoffId: string,
): Promise<{ handoff_id: string; acknowledged_at: string; status: string }> {
  const { data } = await apiClient.post<{
    handoff_id: string;
    acknowledged_at: string;
    status: string;
  }>(`/api/v1/handoffs/${handoffId}/ack`);
  return data;
}

export async function listPendingHandoffs(): Promise<PendingHandoff[]> {
  const { data } = await apiClient.get<{ items: PendingHandoff[] }>(
    "/api/v1/me/handoffs/pending",
  );
  return data.items;
}
